import getNormalizedParamValue from "./getNormalizedParamValue";

const getParamsFromVariationId = (configurationId, variationId, parameters, extraSuffixes) => {
  if (variationId == null) {
    return parameters?.map((parameter) => ({
      id: parameter.id,
      value: parameter.defaultValue,
    }));
  }
  const paramsFromUrl = variationId
    .replace(`${configurationId}-`, "")
    .split("-");

  // Only parameters with values contribute segments to the variation ID
  let segmentIdx = 0;
  const result = parameters?.map((parameter) => {
    const hasValues = Array.isArray(parameter.values) && parameter.values.length > 0;
    if (!hasValues) {
      return { id: parameter.id, value: null };
    }
    const segment = paramsFromUrl[segmentIdx++];
    const matched = parameter.values.find(
      (value) =>
        getNormalizedParamValue(value, configurationId, extraSuffixes).toString() === segment
    );
    return { id: parameter.id, value: matched };
  });
  return result;
};

export default getParamsFromVariationId;
